import { Component, OnInit, ViewChild } from "@angular/core";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { StudyReportWizardService } from "../../../services/wizard/study-report/study-report.wizard.service";
import { MatDialog, MatTabChangeEvent, MatTabGroup } from "@angular/material";
import { SafeResourceUrl } from "@angular/platform-browser";
import { PdfService } from "../../../services/pdf.service";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { StudyReportEdit } from "../../../model/study-report-edit";
import { ResizedEvent } from "angular-resize-event";
import { MenuService } from "src/app/services/menu.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ReportViewer } from "../../../model/report-viewer";
import { StudyReportService } from "../../../services/study-report/study-report.service";
import { AuthService } from "src/app/services/auth.service";
import { StudyReportTypeModalityEnum } from "src/app/model/study-report/study-report-type-modality";
import { StudyReportEditTxControlComponent } from "../../controls/study-report/study-report-edit-tx-control/study-report-edit-tx-control.component";
import { SearchMedicalReportCategory } from "src/app/model/study-report/search-medical-report-category-response";
import { StudyReportAuditDiagnosesDialogComponent } from "../../dialogs/study-report-audit-diagnoses-dialog/study-report-audit-diagnoses-dialog.component";
@Component({
  // tslint:disable-next-line:component-selector
  selector: "study-report-wizard-component",
  templateUrl: "./study-report-wizard.component.html",
  styleUrls: ["./study-report-wizard.component.css"],
})
export class StydyReportWizardComponent implements OnInit {
  constructor(
    public studyReportWizardService: StudyReportWizardService,
    private authService: AuthService,
    private pdfService: PdfService,
    private formBuilder: FormBuilder,
    private menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private studyReportService: StudyReportService,
    private notificationToastService: NotificationToastService,
  ) {
    this.medicalorderId = studyReportWizardService.medicalOrderId;
    this.medicalApponitmentId = studyReportWizardService.medicalAppointmentId;
    this.studyReportId = studyReportWizardService.studyReportId;
    this.wordDocumentOpen = false;
    this.menuService.setMenuTitle("Servicio", "Informar");
    this.form = this.formBuilder.group({
      StudyReportEdit: [null, [Validators.required]],
    });
  }

  onReAppointmentChange() {
    this.cancel();
  }

  get isReadOnly(): boolean {
    return this.studyReportWizardService.isReadOnly;
  }

  get canReverse(): boolean {
    return this.studyReportWizardService.canReverse();
  }

    get isAudit(): boolean {
    return  this.studyReportWizardService.isAudit;
  }


  @ViewChild("txControlReportEdit", { static: false })
  txControlReportEdit: StudyReportEditTxControlComponent | null;
  @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;
  medicalorderId: number;
  medicalApponitmentId: number;
  studyReportId: number;
  loadingAction: boolean;
  pdfResult: any;
  loading: boolean;
  form: FormGroup;
  widthExp = 800;
  safeResourceUrl: SafeResourceUrl;
  wordDocumentOpen: boolean;
  returnUrl: string;
  txControlEnabled: boolean = false;
  loadEditor: boolean;
  activeTabIndex: number = 0;
  reportTabActivated: boolean = false;
  noFooter:  boolean = false;

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
  }

  async ngOnInit() {
    try {
      this.loading = true;
      if (this.isAudit) {
        this.activeTabIndex = 1;
        this.loadEditor = true;
        this.reportTabActivated = true;
      }

      this.route.params.subscribe((params) => {
        this.returnUrl = params["returnUrl"];
      });

      this.txControlEnabled =
        this.authService.getTxControlUrl() &&
        this.authService.getTxControlUrl() !== "null" &&
        this.authService.getTxControlUrl().length > 0;

      const info = await this.studyReportWizardService.getStudyReportEditInfo();

      if (info) {
        const studyReportEdit: StudyReportEdit = new StudyReportEdit();
        studyReportEdit.PhysicianId = this.studyReportWizardService.physicianId;
        studyReportEdit.StudyReportId =
          this.studyReportWizardService.studyReportId;
        studyReportEdit.StudyReportText = info.StudyReportText.Text;
        studyReportEdit.StudyReportConclusion = info.StudyReportText.Conclusion;
        this.noFooter = info.NoFooter;
        studyReportEdit.MedicalApponitmentId =
          this.studyReportWizardService.getMedicalOrderOperation().MedicalApponitmentId;
        studyReportEdit.Protocol =
          this.studyReportWizardService.getMedicalOrderOperation().Protocol;
        studyReportEdit.PatientId = this.studyReportWizardService.patientId;
        studyReportEdit.PracticeName =
          this.studyReportWizardService.practiceName;
        studyReportEdit.ServiceName = this.studyReportWizardService.serviceName;

        if (this.txControlEnabled) {
          this.txControlEnabled =
            this.studyReportWizardService.serviceInformaTxControl;
        }


        studyReportEdit.DeliveryDate =
          this.studyReportWizardService.deliveryDate;
        studyReportEdit.PhysicianSignatureOne = info.PhysicianSignatureOne;
        studyReportEdit.PhysicianSignatureTwo = info.PhysicianSignatureTwo;
        studyReportEdit.PhysicianSignatureThree = info.PhysicianSignatureThree;
        studyReportEdit.PhysicianSignatureFour = info.PhysicianSignatureFour;
        studyReportEdit.PhysicianSignatureFive = info.PhysicianSignatureFive;
        studyReportEdit.PhysicianSignatureSix = info.PhysicianSignatureSix;

        studyReportEdit.StructuredDiagnosisColumnItems =
          info.StructuredDiagnosisColumnItems;

        studyReportEdit.StructuredDiagnosisColumns =
          info.StructuredDiagnosisColumns;

        if (
          info.ReportViewer &&
          this.canReverse &&
          this.studyReportWizardService.isReadOnly
        ) {
          const pdfUrl = this.pdfService.base64ToPdfUrl(
            info.ReportViewer.ReportBase64,
          );
          this.safeResourceUrl =
            this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
        }

        this.form.patchValue({
          StudyReportEdit: studyReportEdit,
        });
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loading = false;
    }
  }

  async setDiagnoses() {
    const dialogRef = this.dialog.open(StudyReportAuditDiagnosesDialogComponent, {
      width: "40%",
      height: "220px",
    });

    const selectedCategory =
      (await dialogRef.afterClosed().toPromise()) as SearchMedicalReportCategory;

    if (!selectedCategory) {
      return;
    }

    try {
      this.loadingAction = true;
      await this.studyReportService.setDiagnosesByStudyReportId(
        selectedCategory.Id,
        this.studyReportId,
      );
      this.notificationToastService.success(
        "Se clasificó el informe correctamente.",
        "Informe",
      );
    } catch (err) {
      const error = err as any;
      this.notificationToastService.error(
        JSON.stringify(error && error.error ? error.error : error),
        "Informe",
      );
    } finally {
      this.loadingAction = false;
    }
  }

  async setDiagnosesAndExport() {
    const dialogRef = this.dialog.open(StudyReportAuditDiagnosesDialogComponent, {
      width: "40%",
      height: "220px",
    });

    const selectedCategory =
      (await dialogRef.afterClosed().toPromise()) as SearchMedicalReportCategory;

    if (!selectedCategory) {
      return;
    }

    try {
      this.loadingAction = true;
      await this.studyReportService.setDiagnosesAndExport(
        selectedCategory.Id,
        this.medicalApponitmentId,
        this.studyReportId,
      );
      this.notificationToastService.success(
        "Se clasificó y publicó el informe correctamente.",
        "Informe",
      );
    } catch (err) {
      const error = err as any;
      this.notificationToastService.error(
        JSON.stringify(error && error.error ? error.error : error),
        "Informe",
      );
    } finally {
      this.loadingAction = false;
    }
  }


  selectedTabChange(event: MatTabChangeEvent): void {
    this.activeTabIndex = event.index;
    this.loadEditor = false;

    if (event.tab.textLabel === "Datos generales e informe") {
      this.loadEditor = true;
      this.reportTabActivated = true;
    }
  }

  updateEditor(): void {
    // this.loadEditor = true;
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  async update() {
    try {
      this.loadingAction = true;
      const edit = <StudyReportEdit>this.form.getRawValue().StudyReportEdit;
      if (this.txControlReportEdit) {
        edit.StudyReportText = await this.txControlReportEdit.getText();
      }
      const result =
        await this.studyReportWizardService.studyReportUpdate(edit);

      if (result) {
        await this.cancel();
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingAction = false;
    }
  }

  studyReportStateReverse(): void {
    this.studyReportWizardService.studyReportStateReverse(async () => {
      await this.cancel();
    });
  }

  editInWord(): boolean {
    return this.studyReportWizardService.editInWord;
  }

  async studyReportConfirmed(result: any) {
    try {
      this.loadingAction = true;

      const report = <StudyReportEdit>this.form.getRawValue().StudyReportEdit;

      await this.studyReportWizardService.studyReportConfirm(
        this.txControlEnabled === true
          ? StudyReportTypeModalityEnum.TxControl
          : StudyReportTypeModalityEnum.Legacy,
        report,
        result.structuredDiagnosisColumnItems,
      );

      if (this.studyReportWizardService.setControlAdmin) {
        this.studyReportService.adminControled([
          {
            StudyReportId: (<StudyReportEdit>(
              this.form.getRawValue().StudyReportEdit
            )).StudyReportId,
          },
        ]);
      }

      await this.cancel();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingAction = false;
    }
  }

  async cancel() {
    try {
      this.loadingAction = true;
      await this.studyReportService.studyReportUnlock(
        this.studyReportWizardService.studyReportId,
      );
      if (!this.returnUrl) {
        history.back();
      } else {
        this.router.navigate([this.returnUrl]);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingAction = false;
    }
  }
}
